import { render } from "./proofCollect.vue?vue&type=template&id=50d0735b&scoped=true"
import script from "./proofCollect.vue?vue&type=script&lang=js"
export * from "./proofCollect.vue?vue&type=script&lang=js"

import "./proofCollect.vue?vue&type=style&index=0&id=50d0735b&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d0735b"]])

export default __exports__